export default {
  // 利用規約のバージョン
  TOS_VERSION: "20220912",
};
